"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _formatCommodityData = require("../../utils/formatCommodityData");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _cmsDesignComponent = require("@tencent/cms-design-component");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const formatSMEFreeTabCard = (properties, options = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const modTitle = properties.modTitle,
    color = properties.color,
    _properties$contactUs = properties.contactUsData,
    contactUsData = _properties$contactUs === void 0 ? {} : _properties$contactUs,
    _properties$tabCardDa = properties.tabCardData,
    tabCardData = _properties$tabCardDa === void 0 ? {} : _properties$tabCardDa;
  const _contactUsData$btnLis = contactUsData.btnList,
    btnList = _contactUsData$btnLis === void 0 ? [] : _contactUsData$btnLis;
  const _tabCardData$list = tabCardData.list,
    list = _tabCardData$list === void 0 ? [] : _tabCardData$list;
  const buttonConfig = btnList.map((item, index) => {
    const _item$txt = item.txt,
      txt = _item$txt === void 0 ? '' : _item$txt,
      _item$commodityObject = item.commodityObject,
      commodityObject = _item$commodityObject === void 0 ? '{}' : _item$commodityObject,
      _item$href = item.href,
      href = _item$href === void 0 ? '' : _item$href,
      _item$backgroundColor = item.backgroundColor,
      backgroundColor = _item$backgroundColor === void 0 ? '' : _item$backgroundColor,
      _item$txtColor = item.txtColor,
      txtColor = _item$txtColor === void 0 ? '' : _item$txtColor;
    const formattedHref = formatUrlString(href);
    const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
    const itemData = _objectSpread(_objectSpread({
      key: `${index + 1}`,
      txt,
      href: formattedHref
    }, resultCommodityObject), {}, {
      extendProps: {
        'report-event-goal': 'click_sme_free_tab_card',
        'report-event': 'click_sme_free_tab_card_top_button',
        'report-ext1': `${index + 1}`,
        'report-ext2': txt,
        'report-ext3': formattedHref
      },
      onCallback: null,
      backgroundColor,
      txtColor
    });
    itemData.onCallback = function () {
      // console.log('formatSMEFreeTabCard--', itemData);
      window.asyncReceiveCommodity(itemData);
    };
    return itemData;
  });
  contactUsData.buttonConfig = buttonConfig;
  const configuration = list.map((item, index) => {
    const _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$duration = item.duration,
      duration = _item$duration === void 0 ? '' : _item$duration,
      _item$content = item.content,
      content = _item$content === void 0 ? '' : _item$content,
      _item$but_txt = item.but_txt,
      but_txt = _item$but_txt === void 0 ? '' : _item$but_txt,
      _item$backgroundUrl = item.backgroundUrl,
      backgroundUrl = _item$backgroundUrl === void 0 ? '' : _item$backgroundUrl,
      _item$but_href = item.but_href,
      but_href = _item$but_href === void 0 ? '' : _item$but_href,
      _item$text_list = item.text_list,
      text_list = _item$text_list === void 0 ? [] : _item$text_list;
    const formattedHref = formatUrlString(but_href);
    return {
      title,
      duration,
      content: formatUrlInText(content),
      but_txt,
      backgroundUrl,
      but_href: formattedHref,
      text_list,
      extendProps: {
        'report-event-goal': 'click_sme_free_tab_card',
        'report-event': 'click_sme_free_tab_card_list_button',
        'report-ext1': index,
        'report-ext2': but_txt,
        'report-ext3': formattedHref
      }
    };
  });
  tabCardData.configuration = configuration;
  return {
    modTitle,
    bgColor: color,
    contactUsData,
    tabCardData
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatSMEFreeTabCard = formatSMEFreeTabCard(data, {
        domains
      }),
      modTitle = _formatSMEFreeTabCard.modTitle,
      contactUsData = _formatSMEFreeTabCard.contactUsData,
      tabCardData = _formatSMEFreeTabCard.tabCardData,
      bgColor = _formatSMEFreeTabCard.bgColor;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_smeFreeTabCard', componentKey, modTitle])), /*#__PURE__*/React.createElement(_cmsDesignComponent.SMEFreeTabCard, {
      style: bgStyle,
      contactUsData: contactUsData,
      tabCardData: tabCardData
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}